var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriendsAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0674 31.4252C25.3152 31.4252 32.0014 24.739 32.0014 16.4912C32.0014 8.24341 25.3152 1.55724 17.0674 1.55724C8.81958 1.55724 2.13342 8.24341 2.13342 16.4912C2.13342 24.739 8.81958 31.4252 17.0674 31.4252ZM17.0674 32.7988C26.0738 32.7988 33.375 25.4977 33.375 16.4912C33.375 7.48476 26.0738 0.183594 17.0674 0.183594C8.06093 0.183594 0.759766 7.48476 0.759766 16.4912C0.759766 25.4977 8.06093 32.7988 17.0674 32.7988Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5033 17.1197L9.63281 17.1197L9.63281 15.7461L24.5033 15.7461L24.5033 17.1197Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3842 23.739L16.3842 9.24609L17.7578 9.24609L17.7578 23.739L16.3842 23.739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsAdd);
export default __webpack_public_path__ + "static/media/FriendsAdd.8e7e576b47a898f0614299dc74195e9a.svg";
export { ForwardRef as ReactComponent };